export { makePageClassificationService } from './pageClassificationService';
export { pageTemplates } from './pageTemplate';

export type { AttributeTypeClassificationRule } from './attributeTypeClassification';
export type { CatchAllClassificationRule } from './catchAllClassification';
export type { DomainKeyClassificationRule } from './domainKeyClassification';
export type { PageClassification } from './pageClassification';
export type {
  ClassifyPage,
  PageClassificationService,
} from './pageClassificationService';
export type { ClassificationRules } from './rules';
export type { SlugClassificationRule } from './slugClassification';
export type {
  ContentModuleSlotType,
  PageTemplate,
  PageTemplateName,
} from './pageTemplate';
